import { render, staticRenderFns } from "./WarrantyCustomerInfoSection.vue?vue&type=template&id=6a20fd34"
import script from "./WarrantyCustomerInfoSection.vue?vue&type=script&lang=js"
export * from "./WarrantyCustomerInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports